import { httpClient } from "@/services";
import getUrl from "@/store/modules/maintance/helper";
import { maintainceHeaders } from "@/constants/defaultHeader";

export default {
	state: {
		maintainceLogs: null,
		maintainceFilter: null,
		maintainceSettingsDefault: null,
		maintainceSettings: null,
		maintainceHeaders: [],
	},
	mutations: {
		updateMaintainceSettingsAll(state, payload) {
			state.maintainceSettings = state.maintainceSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateMaintainceSettingsReset(state) {
			state.maintainceSettings = state.maintainceSettingsDefault.map(item => ({ ...item }));
		},
		updateMaintainceLogs(state, { flag, data }) {
			const { filter, settings } = data;
			state.maintainceLogs = data[flag];
			state.maintainceFilter = filter;
			if (settings && settings.length > 0) {
				state.maintainceSettingsDefault = settings;
				state.maintainceSettings = settings.map(item => ({ ...item }));
				state.maintainceHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.maintainceHeaders.push(item);
					}
				});
			} else {
				state.maintainceSettingsDefault = maintainceHeaders[flag];
				state.maintainceSettings = maintainceHeaders[flag].map(item => ({ ...item }));
				state.maintainceHeaders = [];
				maintainceHeaders[flag].map(item => {
					if (item.settings) {
						state.maintainceHeaders.push(item);
					}
				});
			}
		},
		updateMaintainceDelete(state, payload) {
			const item = payload?.item;
			const id = item.id ? item.id : item.employee_id;
			const key = item.id ? 'id' : 'employee_id';
			const index = state.maintainceLogs.findIndex(item => item[key] === id);
			if (index !== -1) state.maintainceLogs.splice(index, 1);
		},
		updateMaintainceSave(state, payload) {
			const { data, type } = payload;
			if (type === 'edit') {
				const key = data?.id ? 'id' : 'employee_id';

				const index = state.maintainceLogs.findIndex((value) => value[key] === data[key]);
				state.maintainceLogs.splice(index, 1, data);
			} else {
				state.maintainceLogs.unshift(data);
			}
		},
	},
	actions: {
		async onMaintainceSettingsSave({ dispatch, state }, flag) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post(`/${ flag }/settings`, { settings: state.maintainceSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onMaintainceSettingsAll({ commit }, payload) {
			commit('updateMaintainceSettingsAll', payload);
		},
		onMaintainceSettingsReset({ commit }) {
			commit('updateMaintainceSettingsReset');
		},
		async getMaintainceLogs({ commit, dispatch }, info) {
			const { type = 'get', flag, filterModList: value = '' } = info;
			const url = type === 'post' ? `/${ flag }/list` : `/${ flag }`;

			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient[type](url, value);
				if (data && !data.status) {
					const info = { data, flag };
					await commit("updateMaintainceLogs", info);
					commit('updateSettings', { settings: data.settings, key: flag, defaultHeader: maintainceHeaders[flag] });
					dispatch("actionPreloader", false);
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getMaintainceDelete({ commit, dispatch }, value) {
			const { flag, item } = value;
			const id = item.id ? item.id : item.employee_id;

			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.delete(`/${ flag }/${ id }`);
				if (data && data.status) {
					await commit("updateMaintainceDelete", value);
					dispatch("actionPreloader", false);
					dispatch("setAlert", {
						type: "success",
						message: "Delete success",
					});
				} else {
					dispatch("actionPreloader", false);
					dispatch("setAlert", {
						type: "error",
						message: "Delete error",
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getMaintainceSave({ commit, dispatch }, info) {
			this.state.closeDialog = false;
			try {
				dispatch("actionPreloader", true);
				const { value, flag, type } = info;
				const { TYPE, URL } = getUrl(flag, type);
				const { id, employee_id } = value;

				let modUrl = URL;
				if (type === 'edit') modUrl = `${ URL }${ id ?? employee_id }`;
				const { data } = await httpClient[TYPE](modUrl, value);

				if (data && !data.error) {
					const info = { data, type };
					await commit("updateMaintainceSave", info);
					dispatch("actionPreloader", false);
					dispatch("setAlert", { type: "success", message: "Saving Successfully", });
					return true;
				}

				dispatch("actionPreloader", false);
				dispatch("setAlert", { type: "error", message: "Saving error" });
			} catch (error) {
				console.error(error);
			}
		},
		async getMaintainceComments(context, args) {
			const { flag, id } = args;
			try {
				const { data } = await httpClient.get(`/${ flag }/description/${ id }`);
				if (data && !data.status) return data;
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		maintainceLogs: s => s.maintainceLogs,
		maintainceFilter: s => s.maintainceFilter,
		maintainceSettingsDefault: s => s.maintainceSettingsDefault,
		maintainceSettings: s => s.maintainceSettings,
		maintainceHeaders: s => s.maintainceHeaders
	}
};

